module.exports = __webpack_public_path__ + "static/media/top1.72f02d70.webp";